<script lang="ts">
  import AuthForm from "./components/AuthForm.svelte";
  import { link, settings, t } from "../../../core";
  import axios, { AxiosError } from "axios";
  import Input from "../../elements/Input.svelte";
  import FormErrors from "../../elements/FormErrors.svelte";
  import { emailValid } from "./components/helpers";

  let email: string = "";

  let errorMessage: string = "";
  let isLoading: boolean;
  let isDisabled: boolean;
  let isSuccess: boolean;

  $: isDisabled = email.trim() === "";

  function submit() {
    errorMessage = "";
    isSuccess = false;
    isLoading = true;

    if (emailValid(email) === false) {
      errorMessage = t("Error.InvalidEmail.Title");
      isLoading = false;
      return;
    }

    axios
      .post("/api/Customer/forgotpassword", { email })
      .then(() => (isSuccess = true))
      .catch((err: AxiosError) => (errorMessage = err?.response?.data))
      .finally(() => (isLoading = false));
  }
</script>

<svelte:head>
  <title>{t("Page.ForgotPassword.Title")}</title>
</svelte:head>

<AuthForm
  title={t("General.ForgotPassword.Title")}
  description={t("General.EnterEmailAndResetPass.Title")}
  submit={t("General.SendEmail.Title")}
  {isLoading}
  {isDisabled}
  {isSuccess}
  on:click={submit}
>
  {#if isSuccess}
    <div class="success-message">{t("Forgot.Success.Label")}</div>
  {:else}
    <Input
      name="useremail"
      type="email"
      placeholder={t("General.Email.Title")}
      bind:value={email}
    />

    {#if errorMessage}
      <FormErrors {errorMessage} />
    {/if}
  {/if}

  <a slot="link" class="link" use:link href={settings?.loginPageUrl}>
    {t("Forgot.ReturnToLogin.Title")}
  </a>
</AuthForm>

<style lang="scss">
  .success-message {
    margin-bottom: 16px;
  }
</style>
